import { keyframes, css } from 'styled-components';

// ─── Page entrance animations ───────────────────────────────────────────────

export const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const fadeInDown = keyframes`
  from { opacity: 0; transform: translateY(-12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const fadeInScale = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to   { opacity: 1; transform: scale(1); }
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

// ─── Result highlight ────────────────────────────────────────────────────────

export const resultPulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(59,130,246,0.35); }
  60%  { box-shadow: 0 0 0 6px rgba(59,130,246,0); }
  100% { box-shadow: 0 0 0 0 rgba(59,130,246,0); }
`;

// ─── Aircraft flight path ────────────────────────────────────────────────────

// Diagonal descent: starts upper-left, exits lower-right
export const aircraftFly = keyframes`
  0%   { transform: translate(-12vw, -20px) rotate(-4deg); opacity: 0; }
  8%   { opacity: 0.55; }
  88%  { opacity: 0.55; }
  100% { transform: translate(108vw, 90px) rotate(-4deg); opacity: 0; }
`;

// Subtle banking oscillation overlaid on the flight path
export const aircraftBank = keyframes`
  0%   { transform: rotate(-4deg); }
  25%  { transform: rotate(-2.5deg); }
  50%  { transform: rotate(-4.5deg); }
  75%  { transform: rotate(-3deg); }
  100% { transform: rotate(-4deg); }
`;

// ─── Background elements ─────────────────────────────────────────────────────

export const horizonGlow = keyframes`
  0%   { opacity: 0.18; }
  50%  { opacity: 0.28; }
  100% { opacity: 0.18; }
`;

export const cloudDrift = keyframes`
  0%   { transform: translateX(0); }
  100% { transform: translateX(-60px); }
`;

export const radarSweep = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const starTwinkle = keyframes`
  0%, 100% { opacity: 0.2; }
  50%       { opacity: 0.5; }
`;

// ─── Contrail fade ────────────────────────────────────────────────────────────

export const contrailFade = keyframes`
  0%   { opacity: 0.25; }
  50%  { opacity: 0.12; }
  100% { opacity: 0.25; }
`;

// ─── Language switcher ────────────────────────────────────────────────────────

export const langSlide = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

// ─── Reduced-motion guard ─────────────────────────────────────────────────────
// Wrap any animation css with this to respect prefers-reduced-motion

export const withMotion = (animationCss) => css`
  @media (prefers-reduced-motion: no-preference) {
    ${animationCss}
  }
`;
